import { Suspense } from 'react';
import PropTypes from 'prop-types';
import WdLoading from '../WdLoading';

/**
 * React Suspense defaults
 * For to Avoid Repetition
 */ function WdSuspense(props) {
  return <Suspense fallback={<WdLoading {...props.loadingProps} />}>{props.children}</Suspense>;
}

WdSuspense.propTypes = {
  loadingProps: PropTypes.object,
};

WdSuspense.defaultProps = {
  loadingProps: {
    delay: 0,
  },
};

export default WdSuspense;
